const getDefaultState = () => {
  return {
    version: 'VV 0.3.0',
  }
}

const state = getDefaultState()

const getters = {}

const actions = {

}

const mutations = {

};

export default {
  state,
  getters,
  actions,
  mutations
}
